import { useQuery } from '@tanstack/react-query'
import { getUserStudyPlan } from '../infrastructure/api-content'
import { useUserCourses } from './queries/useUserCourses'

export const useCourseStudyPlan = (courseId?: string) => {
    // Obtener profileId desde useUserCourses
    const { getCourseData } = useUserCourses()
    const profileId = getCourseData(courseId)?.profileId

    // Agregar profileId a queryKey para correcta invalidación de caché
    const queryKey = ['Study Plan', courseId, profileId]

    const { data: plan, ...rest } = useQuery({
        queryKey,
        queryFn: () => {
            if (!profileId) {
                throw new Error('ProfileId is required to fetch study plan')
            }
            return getUserStudyPlan(profileId)
        },
        // Requiere tanto courseId como profileId
        enabled: !!courseId && !!profileId,
    })

    const currentSessionId = plan?.currentSessionId
    const currentSession = plan?.sessions.find(({ id }) => currentSessionId === id)
    const firstSession = plan?.sessions.at(0)
    const firstStepId = firstSession?.steps.at(0)?.id

    const findSessionById = (sessionId?: string) => plan?.sessions.find(({ id }) => id === sessionId)
    const findSessionByStepId = (stepId?: string) => plan?.sessions.find(session => session.steps.some(({ id }) => id === stepId))
    const findStepById = (stepId?: string) =>
        plan?.sessions.map(session => session.steps.find(({ id }) => id === stepId)).find(step => step)

    return {
        plan,
        firstSession,
        firstStepId,
        currentSessionId,
        currentSession,
        findSessionByStepId,
        findSessionById,
        findStepById,
        queryKey,
        ...rest,
    }
}
